// extracted by mini-css-extract-plugin
export default {"tabs":"root_tabs-for-public-area-mobile-module__tabs___x_x6T","menuContainer":"root_tabs-for-public-area-mobile-module__menuContainer___xts5m"};